import { render, staticRenderFns } from "./order_detail.vue?vue&type=template&id=1c4eb524&scoped=true&"
import script from "./order_detail.vue?vue&type=script&lang=js&"
export * from "./order_detail.vue?vue&type=script&lang=js&"
import style0 from "./order_detail.vue?vue&type=style&index=0&id=1c4eb524&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4eb524",
  null
  
)

export default component.exports